import { useEffect, useState, useRef } from "react";
import { FaPrint } from "react-icons/fa";
import emailjs from "emailjs-com";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

const SuccessGift = () => {
  const hasProcessed = useRef(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [orderInfo, setOrderInfo] = useState({});
  const cardRef = useRef();




  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <div
        ref={cardRef}
        style={{
          maxWidth: "600px",
          margin: "2rem auto",
          padding: "2rem",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          backgroundColor: "#fff",
          position: "relative",
          fontFamily: "Nunito Sans, sans-serif",
          color: "#404F5E",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <img
            src="https://fonts.gstatic.com/s/e/notoemoji/latest/1f973/512.gif"
            alt="success"
            style={{ maxWidth: 50, marginBottom: 12 }}
          />
          <h1 style={{ color: "#88B04B", fontWeight: 900, fontSize: 40 }}>
          We received your request...
          </h1>
          <p style={{ fontSize: 18, margin: "1rem 0" }}>
            Your Gift is on its way!!!<br />
          
          </p>
        </div>



      </div>

      {modalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "2rem",
              borderRadius: "8px",
              maxWidth: "400px",
              textAlign: "center",
            }}
          >
            <h2>Congrats!</h2>
            <p>Your gift is on its way</p>
            <button
              onClick={() => setModalOpen(false)}
              style={{
                backgroundColor: "#88B04B",
                color: "#fff",
                border: "none",
                padding: "0.5rem 1rem",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SuccessGift;
